import React from "react";

const Contact = () => {
    return (
        <div className="bg-[#F2F1F0] text-[#144E73] font-sans min-h-screen pt-12 pb-20 px-6">
            <div className="max-w-6xl mx-auto">
                <h1 className="text-4xl md:text-5xl font-bold text-primarymb-10 text-center">
                    Contact Us
                </h1>

                <div className="bg-white border border-[#1D4E80] rounded-xl shadow overflow-hidden">
                    <div className="grid md:grid-cols-2 gap-0">
                        {/* Left Column: Contact Info */}
                        <div className="p-6 md:p-10 space-y-4 text-sm md:text-base flex flex-col justify-between">
                            <div>
                                <p>
                                    <strong>Office Address:</strong><br />
                                    Office Suite 1, Pasteur Court,<br />
                                    201 Pasteur Blvd,<br />
                                    Vanderbijlpark, South Africa
                                </p>

                                <p className="pt-4">
                                    <strong>Postal Address:</strong><br />
                                    P.O. Box 6269<br />
                                    Vanderbijlpark, 1900<br />
                                    South Africa
                                </p>

                                <p className="pt-4"><strong>Phone:</strong> +27 (0) 16 940 4444</p>
                                <p><strong>Fax:</strong> +27 (0) 11 252 9219</p>
                                <p>
                                    <strong>Email:</strong>{" "}
                                    <a
                                        href="mailto:mrd@wol.co.za"
                                        className="underline text-primaryhover:text-[#FEB339] transition"
                                    >
                                        mrd@wol.co.za
                                    </a>
                                </p>
                                <p>
                                    <a
                                        href="mailto:bookings@beneckegroup.com"
                                        className="underline text-primaryhover:text-[#FEB339] transition"
                                    >
                                        bookings@beneckegroup.com
                                    </a>
                                </p>
                            </div>

                            <div className="pt-4">
                                <a
                                    href="https://wa.me/27169404444?text=Hi%2C%20I%E2%80%99d%20like%20to%20enquire%20about%20accommodation%20at%20the%20Benecke%20Group."
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-block bg-[#F29E38] text-[#023059] px-5 py-2 rounded-full font-semibold shadow hover:bg-opacity-90 transition"
                                >
                                    Message us on WhatsApp
                                </a>
                            </div>
                        </div>

                        {/* Right Column: Map */}
                        <div className="w-full h-96 md:h-auto">
                            <iframe
                                title="Google Map"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3572.0996472533755!2d27.820000015046493!3d-26.705000983232732!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e95a74fc38398f3%3A0x123456789abcdef!2s201%20Pasteur%20Blvd%2C%20Vanderbijlpark!5e0!3m2!1sen!2sza!4v1683456789000!5m2!1sen!2sza"
                                width="100%"
                                height="100%"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                className="w-full h-full"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
